export default __webpack_public_path__ + "static/media/promocionAlarma6.4d8a1912.png";